import Button from "@/components/Button";
import { useTranslation } from "next-i18next";
import React from "react";
import clsx from "clsx";
import SafeArea from "@/components/safe-area";
import {
	Drawer,
	DrawerContent,
	DrawerDescription,
	DrawerFooter,
	DrawerHeader,
	DrawerTitle,
	NestedRoot,
} from "@/components/ui/drawer";

interface Props {
	visible: boolean;
	onClose: () => void;
	title: string | React.ReactNode;
	content: React.ReactNode | string;
	okText?: string;
	onOk?: () => void;
	zIndex?: number;
	align?: "center" | "left";
	nested?: boolean;
}

export default function NoticeModalBottom(props: Props) {
	const { t } = useTranslation("common");
	const handleOK = () => {
		if (props.onOk) {
			props.onOk();
		} else {
			props.onClose();
		}
	};

	const content = () => {
		return (
			<DrawerContent>
				<div className="mx-auto w-full">
					<DrawerHeader>
						<DrawerTitle className="text-center text-xl font-semibold">{props.title}</DrawerTitle>
						<DrawerDescription></DrawerDescription>
					</DrawerHeader>
					<div className="px-4.5 pb-4">
						<div className={clsx("text-sm font-semibold", props.align === "center" ? "text-center" : "text-left")}>
							{props.content}
						</div>
					</div>
					<DrawerFooter className="px-6">
						<Button block onClick={handleOK}>
							{props.okText || t("ok", { ns: "common" })}
						</Button>
						<SafeArea position="bottom" />
					</DrawerFooter>
				</div>
			</DrawerContent>
		);
	};

	if (props.nested) {
		return (
			<NestedRoot open={props.visible} onOpenChange={(open) => !open && props.onClose()}>
				{content()}
			</NestedRoot>
		);
	}

	return (
		<Drawer open={props.visible} onOpenChange={(open) => !open && props.onClose()}>
			{content()}
		</Drawer>
	);
}
